export const NODE_ENV = process.env.NODE_ENV
export const NETLIFY_REPO = process.env.NETLIFY_REPO
export const NETLIFY_CONTENT_BRANCH = process.env.NETLIFY_CONTENT_BRANCH
export const SITE_DOMAIN = process.env.SITE_DOMAIN
const SUPPORTED_LOCALES = process.env.SUPPORTED_LOCALES || 'de,en'
export const LOCALES = SUPPORTED_LOCALES.split(/[\/\,\s]/).map(x => x.trim())

